import { ReactComponent as CompassRegular } from '../../assets/svg/compass-regular.svg';

export default CompassRegular;
